import React, { Component } from 'react';

import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import Loader from '../../../Common/Component/Loader';

import moment from 'moment-timezone';
import { map, union, spread } from 'lodash';
import { message } from 'antd';
import { Table } from 'antd';
import { DebounceInput } from 'react-debounce-input';

import calibration from "../../../../Assets/images/calibration.svg";

import workOrderStatus from '../../../Common/workOrderStatus.json';
import StatusOutsideAlerter from "../../../Common/statusOutsideAlerter";
import chevronDown from '../../../../Assets/images/chevron-down.png';
import close from '../../../../Assets/images/close.png';
import Datatable from './Datatable';


class SchedulingErrors extends Component {
  state = {
    search_value: "",
    loader: false,
    status: [],
    scheduling_errors_list:[],
    scheduling_errors_list_pagination: { showSizeChanger: false, pageSize: 10, ordering: "", current: 1, total:0, position: ['bottomCenter'] },

  }

  componentDidMount() {
    let { scheduling_errors_list_pagination} = this.state;
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser"))
      : "";
    const default_franchise_uuid = user?.user?.associated_field_offices[0].uuid;
    this.props.getSchedulingErrorsList({
      limit: scheduling_errors_list_pagination.pageSize,
      offset: (scheduling_errors_list_pagination.current * scheduling_errors_list_pagination.pageSize) - scheduling_errors_list_pagination.pageSize,
      ordering: 'service__scheduled_time',
      service__service_order__field_office__uuid: default_franchise_uuid,
    });
    this.setState({loader: true, selected_franchise: default_franchise_uuid});
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { scheduling_errors_list_pagination} = this.state;

    if(props && props.SchedulingErrorsList && props.SchedulingErrorsList.data && props.SchedulingErrorsList.data.results){
      scheduling_errors_list_pagination.total = props.SchedulingErrorsList.data.count;
      this.setState({
        loader: false,
        scheduling_errors_list_pagination,
        scheduling_errors_list:props.SchedulingErrorsList.data.results
      })
    }

  }

  closeStatusFilter = () => {
    this.setState({ toggleStatusFilter: false })
  }

  onStatusChanged = (e, index) => {
    const { status} = this.state;
    let arrStatus = [...status];
    if (e.target.checked) {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.value) === -1 && (element.value === 'scheduled' || element.value === 'forecast')) {
            arrStatus.push(element.value)
          }
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          workOrderStatus.WorkOrderStatus[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }
    } else {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          workOrderStatus.WorkOrderStatus[0]['is_change'] = false;
          workOrderStatus.WorkOrderStatus[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }
    }
    this.setState({ status: arrStatus }, () => {
      this.PaginationChange();
    });
  }

  toggleStatus = () => {
    const { toggleStatusFilter } = this.state;
    if (toggleStatusFilter) {
      this.setState({ toggleStatusFilter: false })
    } else {
      this.setState({ toggleStatusFilter: true, })
    }
  }

  clearStatus = () => {
    workOrderStatus.WorkOrderStatus.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ status: [], toggleStatusFilter: false }, () => {
      this.PaginationChange();
      // clear status drop down
    });
  }

  // status Filter
  renderStatusFilters = () => {
    const { toggleStatusFilter, status } = this.state;
    return (
      <StatusOutsideAlerter
        closeStatusFilter={this.closeStatusFilter}
      >
        <div className="form-group image-input stat-input border-color background-color">
          <div className="fitem">
            <input type="text" readOnly id="txtStatus" placeholder={status && status.length === 0 ? 'Status: All' : `Status: ${status}`} onFocus={() => { this.toggleStatus() }} />
            {status && status.length === 0 &&
              <img src={chevronDown} alt="" onClick={() => { this.toggleStatus() }} />
            }
            {status && status.length > 0 &&
              <img src={close} alt="" onClick={() => { this.clearStatus() }} />
            }
          </div>
          {toggleStatusFilter && <div className="field-dropdown  custom-width">
            <div className="field-dropdown-body custom-height">
              {map(workOrderStatus.WorkOrderStatus, (item, index) => {
                if(item.value === 'scheduled' || item.value === 'forecast' || item.value === 'all')
                  return (
                    <div key={index} className="fitem-check">
                      <input id={item.value} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onStatusChanged(e, index) }} checked={item.is_change} />
                      <label htmlFor={item.value} className="fitem-ck-txt">{item.label}</label>
                    </div>
                  )
              })}
            </div>
          </div>}
        </div>
      </StatusOutsideAlerter>
    )
  }


 

  // Pagination
  PaginationChange = (pagination, filters, sorter) => {
    let { scheduling_errors_list_pagination } = this.state;
    scheduling_errors_list_pagination = pagination ? Object.assign(scheduling_errors_list_pagination, { 'current': pagination?.current }) : scheduling_errors_list_pagination ;

    let ordering;

    if (sorter?.column) {
      ordering = sorter?.order === 'ascend' ? `-${sorter?.columnKey}` : `${sorter?.columnKey}`
    }
    

    let q;
    if (this.state.search_value) {
      q = this.state.search_value;
    }
    let service__status__iexact;
    if(this.state.status && this.state.status.length > 0 && this.state.status.length < 2){
      service__status__iexact = this.state.status.toString();
    }

    const offset = pagination ? (pagination.current - 1) * pagination.pageSize : (scheduling_errors_list_pagination.current - 1) * scheduling_errors_list_pagination.pageSize;
    const limit = pagination ? pagination.pageSize : scheduling_errors_list_pagination.pageSize;

    this.props.getSchedulingErrorsList({
      service__service_order__field_office__uuid: this.state.selected_franchise,
      limit: scheduling_errors_list_pagination.pageSize,
      offset: offset,
      ordering,
      service__status__iexact,
      q
    });

    this.setState({
      loader: true,
      scheduling_errors_list_pagination
    })

  }


  renderTable = () => {
    let { scheduling_errors_list_pagination, scheduling_errors_list} = this.state;
    return (
      <div className="scheduling-error-table">
        <Table
          rowKey={record => record.uuid}
          dataSource={scheduling_errors_list}
          pagination={scheduling_errors_list_pagination}
          // pagination={{ position: [this.state.top, this.state.bottom] }}
          onChange={this.PaginationChange}
          columns={Datatable.ServiceToPerform(this)}
        />
      </div>
    )
  }

  refreshResult = () => {
    this.setState({loader: true,status:[],search_value:''});
    workOrderStatus.WorkOrderStatus.forEach(element => {
      element['is_change'] = false;
    });
    this.props.getSchedulingErrorsList({
      limit: 10,
      offset: 0,
      service__service_order__field_office__uuid: this.state.selected_franchise,
      ordering: '-created_at',
    });
  }

  actionPerform = () =>{
    let {currentRecord,transaction_type} = this.state
    if(transaction_type === 'view_customer'){
      this.props.history.push(`/residential/detail`, { query: { 'id': currentRecord?.service?.service_order?.user?.uuid} })
    }
    else if (transaction_type === 'view_service_order'){
      this.props.history.push(`/residential/detail`, { query: { 'id': currentRecord?.service?.service_order?.user?.uuid,'service_tab':true} })
    }
  }




  render() {
    let { loader, search_value, showAddons } = this.state;
    if(showAddons) {
      this.actionPerform()
    }



    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Sidebar */}
          <Sidebar history={this.props.history} />
          <div className="container">
            <div className="aside-area pt-0 account_module_wrapper">
              <div className="main">
                <div className="filter_wrapper acc-wrap flex background-white">
                  <div className="left_side mr-2 d-block">
                    <h3 className="mb-5">OptimoRoute Scheduling Errors</h3>
                    <h6>List of work orders that failed to be scheduled in OptimoRoute.</h6>
                  </div>
                  <div className="right_side">
                    <div className="form-group flex ai-center w-100 flex-end">
                      <div className="fitem fitem-rinner licon custom-input">
                        <div className="fitem-ricon">
                          <i className="las la-search"></i>
                        </div>
                        <DebounceInput
                          className="form-control"
                          placeholder="Search for customer, service address, coordinates, service order"
                          minLength={3}
                          value={search_value}
                          debounceTimeout={1000}
                          onChange={event => {this.setState({ search_value: event.target.value });this.PaginationChange() }}
                        />
                      </div>
                      <div className="fitem custom-drop-down">
                        {this.renderStatusFilters()}
                      </div>
                      <div className="fitem">
                        <div className="justify-content-end">
                          <button className="btn btn-primary btn-bdr flex"  onClick={() => {this.refreshResult()}}><img className="icoimg ml-0 mr-5" src={calibration} alt="" />Refresh Results</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {this.renderTable()}
                </div>
                {loader ? <Loader /> : ''}
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SchedulingErrors;